(ns common.widgets.advertiser-menu
  (:require [common.widgets.menu :refer [menu]]
            [re-frame.core :as rf]
            [uix.core :refer [$ defui]]))

(defui advertiser-menu [{:keys [archived]}]
  ($ menu
     {:icon "more_vert"
      :items [{:label (if archived
                        "Un-archive"
                        "Archive")
               :on-click (if archived
                           #(rf/dispatch [:resource.advertiser/patch {:archived false}])
                           #(rf/dispatch [:modal/open
                                          {:id :confirm-archive
                                           :props {:event [:resource.advertiser/patch {:archived true}]
                                                   :type "advertiser"}}]))}]}))
